<template>
  <div class="medical-detail-cntainer">
    <TopBg
      title="统一预约平台"
      sub-title="整合预约资源，提供全场景预约服务！"
      :bg="topBg"
    />
    <div class="main-content page">
      <!-- 产品简介 -->
      <div class="section">
        <div class="title">产品简介</div>
        <div class="disc">
          统一预约平台是为医疗机构打造的智能化资源调度与预约管理系统，整合门诊、检查、手术、住院等多类资源，实现全流程一站式预约服务，助力医院实现资源高效分配与患者就医体验的双重提升。
        </div>
        <div class="rows-2">
          <info-item-vue
            title="产品背景"
            desc="在优质医疗资源紧张、患者跨科室多次预约往返的背景下，国家卫健委持续推进“互联网+医疗健康”与分时段精准预约政策，推动医院实现信息互通与服务协同。同时，移动互联网、人工智能与大数据技术为高并发预约、智能排程及资源动态调控提供了坚实支撑，推动预约服务向集约化、智能化发展。"
          >
            <template #icon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
              >
                <path
                  d="M1.88889 7.96777H11.3369C11.8278 7.96777 12.2258 7.56976 12.2258 7.07883V1.88889C12.2258 1.39796 11.8278 1 11.3369 1H1.88889C1.39796 1 1 1.39796 1 1.88889V7.07885C1 7.56976 1.39796 7.96777 1.88889 7.96777ZM24.1111 1H14.6631C14.1722 1 13.7742 1.39796 13.7742 1.88889V7.07885C13.7742 7.56978 14.1722 7.96779 14.6631 7.96779H24.1111C24.602 7.96779 25 7.56978 25 7.07885V1.88889C25 1.39796 24.602 1 24.1111 1ZM24.1111 9.51612H1.88889C1.39796 9.51612 1 9.91408 1 10.405V15.595C1 16.0859 1.39796 16.4839 1.88889 16.4839H24.1111C24.602 16.4839 25 16.0859 25 15.595V10.405C25 9.91408 24.602 9.51612 24.1111 9.51612ZM11.3369 18.0323H1.88889C1.39796 18.0323 1 18.4302 1 18.9211V24.1111C1 24.602 1.39796 25 1.88889 25H11.3369C11.8278 25 12.2258 24.602 12.2258 24.1111V18.9211C12.2258 18.4302 11.8278 18.0323 11.3369 18.0323ZM24.1111 18.0323H14.6631C14.1722 18.0323 13.7742 18.4302 13.7742 18.9212V24.1111C13.7742 24.602 14.1722 25 14.6631 25H24.1111C24.602 25 25 24.602 25 24.1111V18.9211C25 18.4302 24.602 18.0323 24.1111 18.0323Z"
                  fill="#1CB3B8"
                />
                <path
                  d="M24.1111 9.51562H1.88889C1.39796 9.51562 1 9.91359 1 10.4045V15.5945C1 16.0854 1.39796 16.4834 1.88889 16.4834H24.1111C24.602 16.4834 25 16.0854 25 15.5945V10.4045C25 9.91359 24.602 9.51562 24.1111 9.51562Z"
                  fill="#386FC6"
                />
              </svg>
            </template>
          </info-item-vue>
          <info-item-vue
            title="产品概述"
            desc="平台深度融合医院信息系统，提供统一入口，支持分时段精准预约、跨科室协同及智能资源分配。通过算法优化调度，实现患者一站式预约多项服务，显著缩短等待时间，提升资源利用率，是医院实现数字化转型与服务质量升级的核心工具。"
          >
            <template #icon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
              >
                <path
                  d="M15.5495 15.2343H4.79366C4.25764 15.264 3.79607 14.862 3.76629 14.3558C3.73651 13.8347 4.1683 13.4029 4.68943 13.388H15.5198C16.0558 13.3582 16.5173 13.7602 16.5471 14.2665C16.5769 14.7876 16.1451 15.2194 15.624 15.2343H15.5495ZM15.5495 19.8798H4.79366C4.25764 19.9095 3.79607 19.5075 3.76629 19.0013C3.73651 18.4802 4.1683 18.0484 4.68943 18.0335H15.5198C16.0558 18.0037 16.5173 18.4057 16.5471 18.9119C16.5769 19.4331 16.1451 19.8649 15.624 19.8798C15.6091 19.8946 15.5793 19.8946 15.5495 19.8798ZM4.31719 5.92839C4.31719 4.90102 5.18078 4.06722 6.26771 4.06722H8.70957C9.7816 4.06722 10.6601 4.90102 10.6601 5.92839V8.25114C10.6601 9.27851 9.79649 10.1123 8.72446 10.1123H6.2826C5.21056 10.1123 4.33208 9.27851 4.33208 8.25114C4.31719 8.25114 4.31719 5.92839 4.31719 5.92839ZM19.4506 22.679V3.32275C19.4506 2.29538 18.0807 1 17.0087 1H2.5C1.42796 1 0.0581384 2.29538 0.0581384 3.32275V22.679C0.0581384 23.7063 1.42796 25.0017 2.5 25.0017H20.4447C20.668 25.0017 20.8467 24.823 20.8616 24.5997C20.8616 24.4657 20.8021 24.3317 20.6829 24.2572C20.0725 23.8106 19.4506 23.215 19.4506 22.679Z"
                  fill="#1CB3B8"
                />
                <path
                  d="M21.0173 8.41878C21.0173 7.78622 21.5301 7.27344 22.1627 7.27344H24.8547C25.4872 7.27344 26 7.78622 26 8.41878V21.8547C26 22.4872 25.4872 23 24.8547 23H22.1627C21.5301 23 21.0173 22.4872 21.0173 21.8547V8.41878Z"
                  fill="#386FC6"
                />
              </svg>
            </template>
          </info-item-vue>
        </div>
      </div>
      <!-- 痛点分析 -->
      <div class="section">
        <div class="title">痛点分析</div>
        <div class="rows-5">
          <PainsAnalysisItem desc="系统分散独立，患者多次往返，体验差">
            <template #icon
              ><svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.17627 26.4494C1.1762 27.6779 1.4181 28.8943 1.88816 30.0293C2.35821 31.1642 3.04722 32.1955 3.91584 33.0641C4.78446 33.9328 5.81568 34.6219 6.95061 35.092C8.08555 35.5621 9.30197 35.8041 10.5304 35.8041C11.7589 35.8041 12.9753 35.5621 14.1102 35.092C15.2451 34.6219 16.2764 33.9328 17.145 33.0641C18.0136 32.1955 18.7026 31.1642 19.1727 30.0293C19.6427 28.8943 19.8846 27.6779 19.8846 26.4494C19.8846 25.221 19.6427 24.0045 19.1727 22.8696C18.7026 21.7346 18.0136 20.7034 17.145 19.8347C16.2764 18.966 15.2451 18.2769 14.1102 17.8068C12.9753 17.3367 11.7589 17.0947 10.5304 17.0947C9.30197 17.0947 8.08555 17.3367 6.95061 17.8068C5.81568 18.2769 4.78446 18.966 3.91584 19.8347C3.04722 20.7034 2.35821 21.7346 1.88816 22.8696C1.4181 24.0045 1.1762 25.221 1.17627 26.4494Z"
                  fill="#929EB0"
                />
                <path
                  d="M23.6265 18.966C23.6265 20.4545 24.2178 21.8821 25.2703 22.9346C26.3229 23.9872 27.7504 24.5785 29.239 24.5785C30.7275 24.5785 32.155 23.9872 33.2076 22.9346C34.2601 21.8821 34.8514 20.4545 34.8514 18.966C34.8514 17.4775 34.2601 16.0499 33.2076 14.9974C32.155 13.9448 30.7275 13.3535 29.239 13.3535C27.7504 13.3535 26.3229 13.9448 25.2703 14.9974C24.2178 16.0499 23.6265 17.4775 23.6265 18.966Z"
                  fill="#50627F"
                />
                <path
                  opacity="0.8"
                  d="M21.7554 31.1263C21.7554 32.3667 22.2481 33.5564 23.1253 34.4335C24.0024 35.3106 25.192 35.8034 26.4324 35.8034C27.6729 35.8034 28.8625 35.3106 29.7396 34.4335C30.6168 33.5564 31.1095 32.3667 31.1095 31.1263C31.1095 29.8859 30.6168 28.6962 29.7396 27.8191C28.8625 26.942 27.6729 26.4492 26.4324 26.4492C25.192 26.4492 24.0024 26.942 23.1253 27.8191C22.2481 28.6962 21.7554 29.8859 21.7554 31.1263Z"
                  fill="#929EB0"
                />
                <path
                  d="M32.9805 27.3844C32.9805 28.1286 33.2761 28.8424 33.8024 29.3687C34.3287 29.895 35.0424 30.1906 35.7867 30.1906C36.531 30.1906 37.2448 29.895 37.771 29.3687C38.2973 28.8424 38.593 28.1286 38.593 27.3844C38.593 26.6401 38.2973 25.9263 37.771 25.4001C37.2448 24.8738 36.531 24.5781 35.7867 24.5781C35.0424 24.5781 34.3287 24.8738 33.8024 25.4001C33.2761 25.9263 32.9805 26.6401 32.9805 27.3844Z"
                  fill="#50627F"
                />
                <path
                  d="M6.78857 11.4829C6.78857 11.9742 6.88535 12.4608 7.07339 12.9147C7.26143 13.3687 7.53704 13.7812 7.88448 14.1286C8.23193 14.4761 8.6444 14.7517 9.09836 14.9397C9.55232 15.1277 10.0389 15.2245 10.5302 15.2245C11.0216 15.2245 11.5081 15.1277 11.9621 14.9397C12.4161 14.7517 12.8285 14.4761 13.176 14.1286C13.5234 13.7812 13.799 13.3687 13.9871 12.9147C14.1751 12.4608 14.2719 11.9742 14.2719 11.4829C14.2719 10.9915 14.1751 10.505 13.9871 10.051C13.799 9.59704 13.5234 9.18456 13.176 8.83712C12.8285 8.48967 12.4161 8.21406 11.9621 8.02603C11.5081 7.83799 11.0216 7.74121 10.5302 7.74121C10.0389 7.74121 9.55232 7.83799 9.09836 8.02603C8.6444 8.21406 8.23193 8.48967 7.88448 8.83712C7.53704 9.18456 7.26143 9.59704 7.07339 10.051C6.88535 10.505 6.78857 10.9915 6.78857 11.4829Z"
                  fill="#50627F"
                />
                <path
                  opacity="0.8"
                  d="M16.1431 8.67707C16.1431 9.91751 16.6358 11.1071 17.5129 11.9843C18.3901 12.8614 19.5797 13.3541 20.8201 13.3541C22.0606 13.3541 23.2502 12.8614 24.1273 11.9843C25.0045 11.1071 25.4972 9.91751 25.4972 8.67707C25.4972 8.06287 25.3762 7.45468 25.1412 6.88723C24.9061 6.31979 24.5616 5.80419 24.1273 5.36988C23.693 4.93558 23.1774 4.59107 22.61 4.35602C22.0425 4.12098 21.4343 4 20.8201 4C20.2059 4 19.5977 4.12098 19.0303 4.35602C18.4629 4.59107 17.9473 4.93558 17.5129 5.36988C17.0786 5.80419 16.7341 6.31979 16.4991 6.88723C16.264 7.45468 16.1431 8.06287 16.1431 8.67707Z"
                  fill="#929EB0"
                />
              </svg>
            </template>
          </PainsAnalysisItem>
          <PainsAnalysisItem desc="资源分配不均，部分时段和设备闲置与过载并存">
            <template #icon
              ><svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.3483 22.4245L12.3532 7.95117C7.4007 10.4674 4 15.5978 4 21.5333C4 29.9498 10.8229 36.7727 19.2394 36.7727C25.175 36.7727 30.3052 33.372 32.8215 28.4194L18.3484 22.4244L18.3483 22.4244V22.4245Z"
                  fill="#929EB0"
                />
                <path
                  d="M26.5922 6.82314L20.7606 20.902L34.8391 26.7335C35.5844 24.9366 36.0001 22.9683 36.0001 20.9016C36.0001 14.5516 32.114 9.11312 26.5922 6.82314ZM19.2394 18.4894L25.071 4.41088C23.2741 3.66569 21.3059 3.25 19.2394 3.25C17.1729 3.25 15.2047 3.66569 13.4077 4.41093L19.2394 18.4894Z"
                  fill="#929EB0"
                />
                <path
                  d="M26.5919 6.82324L20.7603 20.9021L34.8387 26.7336C35.5841 24.9367 35.9998 22.9684 35.9998 20.9017C35.9998 14.5517 32.1137 9.11322 26.5919 6.82324Z"
                  fill="#50627F"
                />
              </svg>
            </template>
          </PainsAnalysisItem>
          <PainsAnalysisItem
            desc="缺乏智能动态调整能力，难以响应急诊等特殊需求"
          >
            <template #icon
              ><svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.6636 36.1221L25.1403 20.4824L35.363 22.1011L22.6636 36.1221Z"
                  fill="#929EB0"
                />
                <path
                  d="M22.6634 37.7589C22.4268 37.7588 22.1931 37.7076 21.9782 37.6085C21.7634 37.5095 21.5726 37.3651 21.4189 37.1852C21.2652 37.0054 21.1523 36.7944 21.088 36.5667C21.0237 36.339 21.0095 36.1001 21.0464 35.8665L23.5231 20.2251C23.5569 20.0128 23.6321 19.8091 23.7445 19.6259C23.8569 19.4426 24.0044 19.2832 24.1784 19.1569C24.3524 19.0306 24.5496 18.9398 24.7587 18.8898C24.9678 18.8397 25.1847 18.8313 25.3971 18.865L35.6181 20.4837C35.9096 20.5298 36.1833 20.6539 36.4101 20.8428C36.637 21.0317 36.8085 21.2784 36.9066 21.5568C37.0047 21.8352 37.0256 22.135 36.9673 22.4244C36.909 22.7137 36.7735 22.9819 36.5752 23.2006L23.8758 37.2215C23.7224 37.3908 23.5353 37.526 23.3265 37.6186C23.1177 37.7111 22.8918 37.7589 22.6634 37.7589ZM26.502 22.356L25.1402 30.9482L32.117 23.2443L26.5003 22.3543L26.502 22.356Z"
                  fill="#929EB0"
                />
                <path
                  d="M27.6169 4.84082L25.1402 20.4805L14.9175 18.8618L27.6169 4.84082Z"
                  fill="#929EB0"
                />
                <path
                  d="M25.1419 22.1194C25.0558 22.1194 24.9699 22.1126 24.885 22.0992L14.6623 20.4805C14.3707 20.4344 14.097 20.3104 13.8702 20.1215C13.6434 19.9325 13.4719 19.6858 13.3738 19.4074C13.2757 19.129 13.2547 18.8293 13.3131 18.5399C13.3714 18.2505 13.5069 17.9823 13.7052 17.7637L26.4046 3.74272C26.6415 3.48185 26.9561 3.30435 27.3019 3.23661C27.6477 3.16886 28.0061 3.21447 28.3239 3.36667C28.6417 3.51886 28.9019 3.76952 29.0658 4.0814C29.2298 4.39328 29.2888 4.74973 29.234 5.0978L26.7572 20.7391C26.6961 21.1237 26.4999 21.4739 26.2039 21.7269C25.9078 21.9799 25.5313 22.119 25.1419 22.1194ZM18.1633 17.72L23.7801 18.6099L25.1402 10.016L18.1633 17.72Z"
                  fill="#929EB0"
                />
                <path
                  d="M10.3874 22.1184H3.74801C3.31381 22.1184 2.89739 21.9459 2.59036 21.6389C2.28333 21.3319 2.11084 20.9155 2.11084 20.4813C2.11084 20.047 2.28333 19.6306 2.59036 19.3236C2.89739 19.0166 3.31381 18.8441 3.74801 18.8441H10.3874C10.8216 18.8441 11.238 19.0166 11.545 19.3236C11.8521 19.6306 12.0246 20.047 12.0246 20.4813C12.0246 20.9155 11.8521 21.3319 11.545 21.6389C11.238 21.9459 10.8216 22.1184 10.3874 22.1184ZM14.2075 30.3043H7.56809C7.13388 30.3043 6.71746 30.1318 6.41043 29.8248C6.1034 29.5178 5.93091 29.1013 5.93091 28.6671C5.93091 28.2329 6.1034 27.8165 6.41043 27.5095C6.71746 27.2024 7.13388 27.03 7.56809 27.03H14.2075C14.6417 27.03 15.0581 27.2024 15.3651 27.5095C15.6722 27.8165 15.8446 28.2329 15.8446 28.6671C15.8446 29.1013 15.6722 29.5178 15.3651 29.8248C15.0581 30.1318 14.6417 30.3043 14.2075 30.3043ZM14.2075 13.9326H7.56809C7.13388 13.9326 6.71746 13.7601 6.41043 13.453C6.1034 13.146 5.93091 12.7296 5.93091 12.2954C5.93091 11.8612 6.1034 11.4448 6.41043 11.1377C6.71746 10.8307 7.13388 10.6582 7.56809 10.6582H14.2075C14.6417 10.6582 15.0581 10.8307 15.3651 11.1377C15.6722 11.4448 15.8446 11.8612 15.8446 12.2954C15.8446 12.7296 15.6722 13.146 15.3651 13.453C15.0581 13.7601 14.6417 13.9326 14.2075 13.9326Z"
                  fill="#50627F"
                />
              </svg>
            </template>
          </PainsAnalysisItem>
          <PainsAnalysisItem desc="传统预约方式存在数字鸿沟">
            <template #icon
              ><svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.7104 26.398C16.7104 23.9965 17.5081 21.7801 18.8528 19.9996H10.7849C9.9995 19.9996 9.36213 19.3623 9.36213 18.5768V18.2232C9.36213 17.4378 9.9995 16.8004 10.7849 16.8004H22.7469C24.1573 16.1178 25.7446 15.7354 27.4182 15.7354C28.2077 15.7354 28.9725 15.8218 29.7127 15.9821V7.67578C29.7127 5.05639 27.5909 2.93457 24.9715 2.93457H8.74121C6.12182 2.93457 4 5.05639 4 7.67578V32.3235C4 34.9428 6.12182 37.0647 8.74121 37.0647H24.9756C25.3087 37.0647 25.6335 37.0318 25.9502 36.966C20.732 36.2505 16.7104 31.793 16.7104 26.398ZM9.36213 10.7557C9.36213 9.97031 9.9995 9.33294 10.7849 9.33294H22.9319C23.7173 9.33294 24.3547 9.97031 24.3547 10.7557V11.1093C24.3547 11.8947 23.7173 12.5321 22.9319 12.5321H10.7849C9.9995 12.5321 9.36213 11.8947 9.36213 11.1093V10.7557Z"
                  fill="#929EB0"
                />
                <path
                  d="M28.9962 19C24.5781 19 21 22.5817 21 27C21 31.4183 24.582 35 29 35C33.418 35 37 31.4183 37 27C36.9962 22.5817 33.4142 19 28.9962 19ZM33.9856 27.1118C33.9856 27.6014 33.5906 28.0024 33.0997 28.0024H28.8734C28.3864 28.0024 27.9875 27.6053 27.9875 27.1118V22.8901C27.9875 22.4005 28.3826 21.9995 28.8734 21.9995H29.1227C29.6098 21.9995 30.0086 22.3966 30.0086 22.8901V26.0014H33.1035C33.5906 26.0014 33.9895 26.3986 33.9895 26.892L33.9856 27.1118Z"
                  fill="#50627F"
                />
              </svg>
            </template>
          </PainsAnalysisItem>
          <PainsAnalysisItem desc="全院预约数据不互通，管理决策缺乏依据">
            <template #icon
              ><svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M35 14.9474V20C35 24.1853 28.2833 27.5789 20 27.5789C11.7167 27.5789 5 24.1853 5 20V14.9474C5 19.1326 11.7167 22.5263 20 22.5263C28.2833 22.5263 35 19.1326 35 14.9474ZM5 23.3684C5 27.5537 11.7167 30.9474 20 30.9474C28.2833 30.9474 35 27.5537 35 23.3684V28.4211C35 32.6063 28.2833 36 20 36C11.7167 36 5 32.6063 5 28.4211V23.3684ZM20 19.1579C11.7167 19.1579 5 15.7642 5 11.5789C5 7.39368 11.7167 4 20 4C28.2833 4 35 7.39368 35 11.5789C35 15.7642 28.2833 19.1579 20 19.1579Z"
                  fill="#50627F"
                />
                <path
                  d="M5 23.3684C5 27.5537 11.7167 30.9474 20 30.9474C28.2833 30.9474 35 27.5537 35 23.3684V28.4211C35 32.6063 28.2833 36 20 36C11.7167 36 5 32.6063 5 28.4211V23.3684ZM20 19.1579C11.7167 19.1579 5 15.7642 5 11.5789C5 7.39368 11.7167 4 20 4C28.2833 4 35 7.39368 35 11.5789C35 15.7642 28.2833 19.1579 20 19.1579Z"
                  fill="#929EB0"
                />
              </svg>
            </template>
          </PainsAnalysisItem>
        </div>
      </div>
      <!-- 产品价值 -->
      <div class="section">
        <div class="title">产品价值</div>
        <div class="rows-4">
          <value-item-vue
            :title="
              !isMobile
                ? '一站式预约<br/>减少患者排队'
                : '一站式预约，减少患者排队'
            "
            desc="智能规划多项检查顺序，一次性完成预约，缩短等待时间。"
          >
            <template #icon>
              <svg
                width="64"
                height="64"
                viewBox="0 0 64 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M60.9999 28.5801H3.13208V50.5475C3.13208 52.7683 4.01425 54.8982 5.58454 56.4687C7.15483 58.0391 9.28464 58.9215 11.5055 58.9218H52.6256C54.8465 58.9215 56.9764 58.0392 58.5469 56.4687C60.1173 54.8983 60.9997 52.7684 60.9999 50.5475V28.5801Z"
                  fill="#1CB3B8"
                />
                <path
                  d="M52.9674 16.8123H47.746V11.8023C47.7438 9.89037 46.9834 8.05733 45.6314 6.70537C44.2795 5.35341 42.4464 4.59295 40.5345 4.59082H23.6859C21.7739 4.59295 19.9409 5.35341 18.5889 6.70537C17.237 8.05733 16.4765 9.89037 16.4744 11.8023V16.8123H11.1664C9.03627 16.8123 6.99339 17.6585 5.48717 19.1647C3.98095 20.6709 3.13477 22.7138 3.13477 24.8439V28.401H60.9999V24.8439C60.9999 23.7891 60.7921 22.7446 60.3885 21.7701C59.9848 20.7956 59.3931 19.9102 58.6472 19.1644C57.9013 18.4185 57.0158 17.827 56.0413 17.4234C55.0667 17.0198 54.0222 16.8122 52.9674 16.8123ZM21.8288 11.8023C21.8295 11.31 22.0254 10.8381 22.3735 10.4899C22.7216 10.1418 23.1936 9.94594 23.6859 9.94523H40.5345C41.0268 9.94594 41.4987 10.1418 41.8468 10.4899C42.195 10.8381 42.3908 11.31 42.3915 11.8023V16.8123H21.8288V11.8023Z"
                  fill="#386FC6"
                />
                <path
                  d="M41.5048 40.3394H36.278C36.0657 40.3394 35.8621 40.2554 35.7116 40.1057C35.5611 39.9561 35.476 39.7529 35.4748 39.5407V34.3139C35.4748 34.1009 35.3902 33.8966 35.2396 33.746C35.089 33.5954 34.8847 33.5107 34.6717 33.5107H29.5189C29.3059 33.5107 29.1016 33.5954 28.951 33.746C28.8004 33.8966 28.7158 34.1009 28.7158 34.3139V39.5407C28.7146 39.7522 28.6301 39.9546 28.4805 40.1042C28.331 40.2537 28.1285 40.3382 27.9171 40.3394H22.6296C22.4166 40.3394 22.2123 40.424 22.0617 40.5746C21.911 40.7253 21.8264 40.9296 21.8264 41.1426V46.3042C21.8264 46.5172 21.911 46.7215 22.0617 46.8721C22.2123 47.0228 22.4166 47.1074 22.6296 47.1074H27.9206C28.1329 47.1086 28.336 47.1937 28.4857 47.3442C28.6353 47.4947 28.7193 47.6983 28.7193 47.9105V53.2016C28.7193 53.4146 28.804 53.6189 28.9546 53.7695C29.1052 53.9201 29.3095 54.0048 29.5225 54.0048H34.6833C34.8963 54.0048 35.1006 53.9201 35.2512 53.7695C35.4018 53.6189 35.4864 53.4146 35.4864 53.2016V47.8981C35.4864 47.685 35.571 47.4808 35.7217 47.3301C35.8723 47.1795 36.0766 47.0949 36.2896 47.0949H41.5164C41.7294 47.0949 41.9337 47.0103 42.0843 46.8597C42.2349 46.709 42.3195 46.5047 42.3195 46.2917V41.1381C42.319 41.032 42.2974 40.9271 42.256 40.8294C42.2147 40.7317 42.1544 40.6432 42.0786 40.5689C42.0029 40.4947 41.9132 40.4362 41.8147 40.3968C41.7162 40.3574 41.6109 40.3379 41.5048 40.3394Z"
                  fill="white"
                />
              </svg>
            </template>
          </value-item-vue>
          <value-item-vue
            :title="
              !isMobile
                ? '资源智能调度<br/>均衡科室负荷'
                : '资源智能调度，均衡科室负荷'
            "
            desc="基于数据分析实现分时段、分人群错峰预约，降低高峰人流量，缩短候诊时间。"
          >
            <template #icon>
              <svg
                width="64"
                height="64"
                viewBox="0 0 64 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M63.0002 43.3717L45.2617 32.564V38.7642H14.9136C13.8829 38.7421 12.8817 38.4163 12.0354 37.8276C11.1891 37.2389 10.5353 36.4136 10.156 35.455C9.77674 34.4963 9.68882 33.4471 9.90325 32.4388C10.1177 31.4304 10.625 30.5078 11.3615 29.7864C12.098 29.0651 13.031 28.5772 14.0437 28.3838C15.0563 28.1905 16.1034 28.3003 17.0539 28.6995C18.0044 29.0987 18.8159 29.7695 19.3868 30.6279C19.9577 31.4863 20.2626 32.4941 20.2632 33.525V36.3345H28.8214V33.5231C28.8792 30.7599 28.1126 28.0421 26.6194 25.7163C25.1262 23.3906 22.974 21.5624 20.4375 20.4648C17.901 19.3672 15.095 19.05 12.3775 19.5536C9.65995 20.0573 7.15403 21.359 5.17933 23.2927C3.20463 25.2264 1.85066 27.7045 1.29011 30.4109C0.729566 33.1173 0.987845 35.9293 2.03201 38.4883C3.07617 41.0472 4.85889 43.2372 7.1528 44.7789C9.4467 46.3205 12.1478 47.144 14.9116 47.1442H45.2598V54.1776L63.0002 43.3737V43.3717ZM20.4279 63.0013H28.9881V49.7851H20.4279V63.0013ZM32.0804 63.0013H40.6426V49.7851H32.0843L32.0824 63.0013H32.0804ZM32.0804 36.288H40.6426V18.3655H47.0617L36.0292 0.999023L25.0006 18.3655H32.0959V36.288H32.0843H32.0804Z"
                  fill="#386FC6"
                />
                <path
                  d="M63.0002 43.3714L45.2617 32.5636V38.7638H14.9136C13.8829 38.7417 12.8817 38.4159 12.0354 37.8272C11.1891 37.2386 10.5353 36.4132 10.156 35.4546C9.77675 34.496 9.68882 33.4468 9.90325 32.4384C10.1177 31.43 10.625 30.5074 11.3615 29.7861C12.098 29.0647 13.031 28.5768 14.0437 28.3835C15.0563 28.1901 16.1034 28.2999 17.0539 28.6991C18.0044 29.0983 18.8159 29.7691 19.3868 30.6275C19.9577 31.4859 20.2626 32.4937 20.2632 33.5246V36.3341H28.8214V33.5227C28.8792 30.7595 28.1126 28.0417 26.6194 25.716C25.1262 23.3902 22.974 21.562 20.4375 20.4644C17.901 19.3668 15.095 19.0496 12.3775 19.5533C9.65995 20.057 7.15403 21.3587 5.17933 23.2924C3.20463 25.2261 1.85066 27.7042 1.29011 30.4105C0.729566 33.1169 0.987845 35.9289 2.03201 38.4879C3.07617 41.0469 4.85889 43.2369 7.1528 44.7785C9.4467 46.3202 12.1478 47.1436 14.9116 47.1438H45.2598V54.1772L63.0002 43.3733V43.3714ZM20.4279 63.0009H28.9881V49.7847H20.4279V63.0009Z"
                  fill="#1CB3B8"
                />
              </svg>
            </template>
          </value-item-vue>
          <value-item-vue
            title="提升科室运营效率"
            desc="预约操作耗时减少75，设备利用率提升25%，整体工作效率提高40%以上。"
          >
            <template #icon>
              <svg
                width="64"
                height="64"
                viewBox="0 0 64 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M32 21C23.1771 21 16 28.1771 16 37C16 45.8229 23.1771 53 32 53C40.823 53 48 45.8229 48 37C48 28.1771 40.823 21 32 21ZM34.7886 38.5726L34.7795 38.5543C34.2308 39.5324 33.1977 40.2001 32.0002 40.2001C30.2356 40.2001 28.8002 38.7645 28.8002 36.9999C28.8002 35.8844 29.367 34.9063 30.2264 34.3394L30.2173 34.321L40.7681 28.2867L34.7886 38.5726Z"
                  fill="#1CB3B8"
                />
                <path
                  d="M52.1623 20.2802L54.5118 17.9135C54.9269 17.4956 54.9269 16.8189 54.5118 16.402L52.2611 14.1347C51.8463 13.7167 51.1744 13.7167 50.7605 14.1347L48.411 16.5014C44.5789 13.3554 39.8425 11.2859 34.6532 10.7568V6.34489H37.8368C39.0095 6.34489 39.9592 5.38819 39.9592 4.20698V3.13797C39.9592 1.9567 39.0095 1 37.8368 1H26.1633C24.9906 1 24.0409 1.95676 24.0409 3.13791V4.20692C24.0409 5.38819 24.9906 6.34489 26.1633 6.34489H29.347V10.7555C24.1576 11.2858 19.4214 13.3554 15.5893 16.5002L13.2397 14.1335C12.8247 13.7155 12.1531 13.7155 11.7392 14.1335L9.48829 16.4009C9.07331 16.8189 9.07331 17.4955 9.48829 17.9124L11.8378 20.2791C8.19032 24.7881 6 30.5402 6 36.8097C6 51.2733 17.6417 63 32.0001 63C46.3583 63 58 51.2733 58 36.8099C58 30.5413 55.8108 24.7893 52.1623 20.2802ZM32.0001 57.656C20.5919 57.656 11.3061 48.3024 11.3061 36.8108C11.3061 25.3192 20.5919 15.9657 32.0001 15.9657C43.4081 15.9657 52.6938 25.3192 52.6938 36.8107C52.6938 48.3025 43.4081 57.656 32.0001 57.656Z"
                  fill="#386FC6"
                />
              </svg>
            </template>
          </value-item-vue>
          <value-item-vue
            title="数据驱动管理决策"
            desc="实时监控资源状态与预约数据，支持科学排班与资源优化配置。"
          >
            <template #icon>
              <svg
                width="64"
                height="64"
                viewBox="0 0 64 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M58.5371 4.4834H5.46286C4.54658 4.48789 3.66904 4.85359 3.02073 5.5011C2.37241 6.14862 2.00563 7.0257 2 7.94197V45.6134C2 47.5077 3.56429 49.072 5.46286 49.072H58.5371C59.4534 49.0675 60.331 48.7018 60.9793 48.0543C61.6276 47.4067 61.9944 46.5297 62 45.6134V7.94197C61.9944 7.0257 61.6276 6.14862 60.9793 5.5011C60.331 4.85359 59.4534 4.48789 58.5371 4.4834ZM52.9357 30.532H46.8886C45.4914 30.532 44.0986 29.7563 43.4771 28.5177L37.1171 16.8777L30.6029 36.5748C30.14 37.972 29.0514 39.0563 27.6586 39.2105H26.8829C25.4857 39.2105 24.2471 38.5891 23.6257 37.3505L18.3543 28.822H11.0643C10.4519 28.8068 9.86876 28.5567 9.43559 28.1235C9.00241 27.6904 8.75235 27.1072 8.73714 26.4948C8.73714 25.252 9.82143 24.1677 11.0643 24.1677H19.5929C20.3686 24.1677 21.1443 24.6305 21.6071 25.252L26.7286 33.4763L33.2429 13.7791C33.4599 13.0779 33.8624 12.4485 34.4079 11.9574C34.9533 11.4662 35.6214 11.1317 36.3414 10.9891C37.1422 10.8235 37.9753 10.9322 38.7068 11.2975C39.4384 11.6629 40.0257 12.2638 40.3743 13.0034L47.3557 25.7234H52.9357C54.1786 25.7234 55.2629 26.8077 55.2629 28.0505C55.2629 29.2891 54.1786 30.532 52.9357 30.532Z"
                  fill="#1CB3B8"
                />
                <path
                  d="M14.8788 52.9912H50.1288C50.8659 52.9912 51.8431 55.0741 51.8431 56.3341C51.8431 57.5941 50.8659 59.8226 50.1288 59.8226H14.8788C13.2116 59.8226 12.2388 57.5941 12.2388 56.3341C12.2388 55.0741 13.2116 52.9912 14.4159 52.9912H14.8788Z"
                  fill="#386FC6"
                />
              </svg>
            </template>
          </value-item-vue>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBg from "../common/TopBg.vue";
import infoItemVue from "../common/info-item.vue";
import valueItemVue from "../common/value-item.vue";
import PainsAnalysisItem from "../common/pains-analysis-item.vue";

export default {
  name: "Reserve",
  components: {
    TopBg,
    infoItemVue,
    valueItemVue,
    PainsAnalysisItem,
  },
  data() {
    return {
      topBg: require("../../assets/serve/bg02.png"),
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 1000;
    },
  },
};
</script>
